module.exports = __webpack_public_path__ + "img/logotransp.b6945460.png";